export const colorPalette = {
  primary: '#60A5FA',
  secondary: '#86EFAC',
  tertiary: '#FBBF24'
}
